import type { CardProps } from "@karrtopelka/cards/types";
import { plinkoProvocation } from "@karrtopelka/cards/provocations";

/** Card for a landed bucket worth bragging about (≥2x). */
export function buildPlinkoCard(
  mult: number,
  value: number,
  handle: string,
  submit: { total: number; percentile: number } | null,
): CardProps {
  const props: CardProps = {
    game: "plinko",
    display: `${mult >= 100 ? mult.toFixed(0) : mult.toFixed(2)}x`,
    handle,
    provocation: plinkoProvocation(value),
    date: new Date().toISOString().slice(0, 10),
  };
  if (submit && submit.total >= 10) {
    props.rankLine = `top ${submit.percentile}% today`;
  }
  return props;
}
